import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Employee, Pagination } from "@/v2/types";

export default async function FindAllArOfficeStaff({
    limit,
    skip,
    search,
    filter,
}: {
    skip?: number;
    limit?: number;
    search?: string;
    filter?: Record<string, string>;
}): Promise<{ data: Employee[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/employee-ar-office-staff",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
            ...(filter && { ...filter }),
        },
    });

    return res.data;
}
